import {LocationsMap} from './LocationsMap';

export class BigDutchman {

    locationsMap = null;
    locations = {
        data: {
            selectedCountry: null,
            uri: '',
            consultantType: '',
            requestUri: '',
            geocodingWarning: '',
            settings: {},
            geocoding: {}
        },
    }

    constructor() {
        this.addEventListeners();
        this.init();
        this.zipForm();
        setTimeout(() => {
            this.reload();
        }, 5000);
    }
    reload() {
        let map = document.getElementById('c-locations__google-map');

        if (map && map.classList.contains('is-loading')) {
            if (window.UserCentricsService && window.UserCentricsService.isServiceEnabled('Google Maps')) {
                this.loadMap();
            } else {
                if (window.UserCentricsService && !window.UserCentricsService.isServiceEnabled('Google Maps')) {
                    // UserCentricsService is ready, but Google Maps is not enabled => no need to try again
                    return;
                }
                // Retry after UserCentricsService is ready
                setTimeout(() => {
                    this.reload();
                }, 1000);
            }
        }
    }

    loadMap() {
        let vm = this;
        if (!document.getElementById('googleMapsScript')) {
            let googleMapsSrc = document.getElementById('c-locations__map').dataset.scriptSrc;

            if (googleMapsSrc) {
                let googleMapsScript = document.createElement('script');
                googleMapsScript.src = googleMapsSrc;
                googleMapsScript.id = 'googleMapsScript'
                googleMapsScript.onload = function () {
                    if (vm.initLocationsMap()) {
                        vm.initMap();
                        vm.initGeoCoding();
                    }
                }

                document.body.appendChild(googleMapsScript);
            }
        } else {
            if (vm.initLocationsMap()) {
                vm.initMap();
                vm.initGeoCoding();
            }
        }
    }

    addEventListeners() {
        let vm = this;

        // Wait for UserCentricsService to be available
        const setupConsentListener = () => {
            if (window.UserCentricsService) {
                // Register listener for Google Maps consent changes
                window.UserCentricsService.onConsentChange('Google Maps', (hasConsent) => {
                    if (hasConsent) {
                        console.log('Google Maps has consent');
                        vm.loadMap();
                    } else {
                        console.log('Google Maps consent revoked');
                    }
                });
            } else {
                setTimeout(setupConsentListener, 100);
            }
        };

        setupConsentListener();
    }

    init() {
        let mapElement = document.getElementById('c-locations__map');
        if (mapElement) {
            // set required data stuff
            this.locations.data.selectedCountry = mapElement.getAttribute('data-selected-country');
            this.locations.data.uri = mapElement.getAttribute('data-uri');
            this.locations.data.geocodingWarning = mapElement.getAttribute('data-geocoding-warning');
            this.locations.data.consultantType = mapElement.getAttribute('data-consultant-type');
            this.locations.data.requestUri = mapElement.getAttribute('data-request-uri');
            this.locations.data.contentUid = parseInt(mapElement.getAttribute('data-content-uid'), 10) || 0;
            this.locations.data.contentUidHmac = mapElement.getAttribute('data-content-uid-hmac') ?? '';
            this.locations.data.hideResultsOnload = mapElement.getAttribute('data-hide-results-onload');
            let vm = this

            // select country by select box
            let countrySelect1 = document.getElementById('country-select1');
            if (countrySelect1) {
                countrySelect1.onchange = function () {
                    let value = document.getElementById('country-select1').value;
                    if (value) {
                        vm.locationsMap.selectCountryByIsoCode(value);
                    } else {
                        vm.showCountryList(value, null, null, null, true);
                    }
                    document.getElementById('country-select2').value = value;
                };

                document.getElementById('country-select2').onchange = function () {
                    let value = document.getElementById('country-select2').value;
                    if (value) {
                        vm.locationsMap.selectCountryByIsoCode(value);
                    } else {
                        vm.showCountryList(value, null, null, null, true);
                    }
                    document.getElementById('country-select1').value = value;
                };
            }
        }
    }

    initMap() {
        let mapElement = document.getElementById('c-locations__map');

        if (mapElement) {
            this.locationsMap.locations = this.locations;
            this.locationsMap.createParamUrl = this.createParamUrl;
            this.locationsMap.createAjaxActionUrl = this.createAjaxActionUrl;
            this.locationsMap.showCountryList = this.showCountryList;
            this.locationsMap.clearCountryList = this.clearCountryList;
            this.locationsMap.setCountrySelectbox = this.setCountrySelectbox;

            if (this.locations.data.selectedCountry && this.locations.data.hideResultsOnload !== '1') {
                this.locationsMap.selectCountryByIsoCode(this.locations.data.selectedCountry);
            } else if (this.locations.data.onlyCountry && this.locations.data.consultantType === 4) {
                this.locationsMap.selectCountryByIsoCode(this.locations.data.onlyCountry);
            }
        }
    }

    initLocationsMap() {
        let mapContainer = document.getElementById('c-locations__google-map');

        if (mapContainer) {
            const hideOnLoadElements = document.querySelectorAll('#c-locations__map .hide-on-load');
            hideOnLoadElements.forEach(function (element) {
                element.classList.remove('hide-on-load');
            });
            this.locationsMap = new LocationsMap(JSON.parse(mapContainer.getAttribute('data-options')));
            this.locationsMap.openMap();

            setTimeout(() => {
                mapContainer.classList.remove('is-loading');
            }, 500);

            return true;
        }

        return false;
    }

    initGeoCoding() {
        let that = this;
        let geocodeform1 = document.getElementById('geocodeform1');

        if (geocodeform1) {
            document.getElementById('geocodeinput1').onkeyup = function () {
                document.getElementById('geocodeinput2').value = document.getElementById('geocodeinput1').value;
            };
            document.getElementById('geocodeinput2').onkeyup = function () {
                document.getElementById('geocodeinput1').value = document.getElementById('geocodeinput2').value;
            };

            geocodeform1.onsubmit = function (e) {
                e.preventDefault();
                that.geocode(document.getElementById('geocodeinput1').value);
            };

            document.getElementById('geocodeform2').onsubmit = function (e) {
                e.preventDefault();
                that.geocode(document.getElementById('geocodeinput2').value);
            };
        }
    }

    geocode(input) {
        if (input !== '') {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({address: input})
                .then(({results}) => {
                    if (results[0]) {
                        let resultLat = results[0].geometry.location.lat();
                        let resultLng = results[0].geometry.location.lng();

                        if (resultLat && resultLng) {
                            this.locationsMap.showGeocodeInfoWindow(results[0].formatted_address, {
                                lat: resultLat,
                                lng: resultLng
                            });
                            this.showCountryList('DE', null, null, resultLat + ',' + resultLng);
                        } else {
                            window.alert(this.locations.data.geocodingWarning);
                        }
                    } else {
                        window.alert(this.locations.data.geocodingWarning);
                    }
                })
                .catch((e) => window.alert('Geocoder failed due to: ' + e));
        }
    }

    zipForm() {
        let zipform = document.getElementById('zipform');
        let vm = this;

        if (zipform) {
            document.getElementById('zipform').onsubmit = function (e) {
                e.preventDefault();
                vm.zipSearch();
            };
        }
    }

    zipSearch() {
        let zip = document.getElementById('zipinput').value;

        this.showZipList('DE', zip);
    }

    // set country in selectbox by iso code
    setCountrySelectbox(iso2) {
        if (document.getElementById('country-select1')) {
            document.getElementById('country-select1').value = iso2;
            document.getElementById('country-select2').value = iso2;
        }
    }

    clearCountryList() {
        document.getElementById("map-address-list").innerHTML = '&nbsp;';
    }

    // ajax calls to display address lists
    showZipList(isoId, zip, callback) {
        this.clearCountryList();

        if (isoId === null) {
            isoId = 'DE';
        }

        let formData = new FormData();
        formData.append('tx_bdlocations_map[actionName]', 'addressListByZip');
        formData.append('tx_bdlocations_map[arguments][zip]', zip);
        formData.append('tx_bdlocations_map[arguments][countryName]', isoId);
        formData.append('tx_bdlocations_map[arguments][contentUid]', this.locations.data.contentUid);
        formData.append('tx_bdlocations_map[arguments][contentUidHmac]', this.locations.data.contentUidHmac);

        fetch(this.locations.data.uri, {
            method: 'POST',
            cache: 'no-cache',
            body: formData
        }).then(response => {
            if (response.status !== 200) {
                console.error('"showZipList" failed: ' + response.statusText);
            } else {
                return response.text();
            }
        }).then(html => {
            if (html) {
                document.getElementById('map-address-no-list-anchor').style.display = 'none';
                let mapAddressList = document.getElementById('map-address-list');
                mapAddressList.innerHTML = html;
                window.scroll({top: (mapAddressList.offsetTop - 145), left: 0, behavior: 'smooth'});

                if (callback) {
                    callback.call();
                }
            }
        });
    }

    showCountryList(isoId, locationId, regionId, coordinates, scroll, callback) {
        this.clearCountryList();

        if (scroll === undefined) {
            scroll = true;
        }
        if (isoId === undefined || isoId === null) {
            isoId = '';
        }
        if (locationId === undefined || locationId === null) {
            locationId = 0;
        }
        if (regionId === undefined || regionId === null) {
            regionId = '';
        }
        if (coordinates === undefined || coordinates === null) {
            coordinates = '';
        }

        let formData = new FormData();
        formData.append('tx_bdlocations_map[actionName]', 'addressList');
        formData.append('tx_bdlocations_map[arguments][contentUid]', this.locations.data.contentUid);
        formData.append('tx_bdlocations_map[arguments][contentUidHmac]', this.locations.data.contentUidHmac);
        formData.append('tx_bdlocations_map[arguments][countryName]', isoId);
        formData.append('tx_bdlocations_map[arguments][location]', locationId);
        formData.append('tx_bdlocations_map[arguments][region]', regionId);
        formData.append('tx_bdlocations_map[arguments][coordinates]', coordinates);

        fetch(this.locations.data.uri, {
            method: 'POST',
            cache: 'no-cache',
            body: formData
        }).then(response => {
            if (response.status !== 200) {
                console.error('"showCountryList" failed: ' + response.statusText);
            } else {
                return response.text();
            }
        }).then(html => {
            if (html) {
                document.getElementById('map-address-no-list-anchor').style.display = 'none';
                let mapAddressList = document.getElementById('map-address-list');
                mapAddressList.innerHTML = html;
                if (scroll) {
                    window.scroll({top: (mapAddressList.offsetTop - 145), left: 0, behavior: 'smooth'});
                }

                if (callback) {
                    callback.call();
                }
            }
        });

        return false;
    }

    createAjaxActionUrl(requestData) {
        let url = this.locations.data.uri + '&';
        let paramsArray = [];
        for (let data in requestData) {
            if (typeof requestData[data] === 'object' && requestData[data] !== null) {
                paramsArray.push(this.createParamUrl(requestData[data], data));
            } else {
                paramsArray.push(data + '=' + requestData[data]);
            }
        }
        let uri = paramsArray.join('&');
        uri = uri.replace(/#/g, '%23');
        url = url + encodeURI(uri);
        return url;
    }

    createParamUrl(args, paramkey) {
        let paramsArray = [];
        for (let argsKey in args) {
            if (typeof args[argsKey] === 'object' && args[argsKey] !== null) {
                paramkey = paramkey + '[' + argsKey + ']';
                paramsArray.push(this.createParamUrl(args[argsKey], paramkey));
            } else {
                if (args[argsKey] !== null && args[argsKey] !== undefined) {
                    paramsArray.push(paramkey + '[' + argsKey + ']=' + args[argsKey]);
                }
            }
        }
        return paramsArray.join('&');
    }

}

new BigDutchman();

